export function formatPhone(value: string): string {
  const numbersOnly = value.replace(/\D/g, '');

  // Formatação dinâmica
  if (numbersOnly.length <= 2) return numbersOnly;
  if (numbersOnly.length <= 6) return `(${numbersOnly.slice(0, 2)}) ${numbersOnly.slice(2)}`;
  if (numbersOnly.length <= 10) return `(${numbersOnly.slice(0, 2)}) ${numbersOnly.slice(2, 6)}-${numbersOnly.slice(6)}`;

  return `(${numbersOnly.slice(0, 2)}) ${numbersOnly.slice(2, 7)}-${numbersOnly.slice(7, 11)}`;
}
